import { CreateNewsCriticsContext } from "contexts/MightyTool";
import { useContext } from "react";
const useCreateNewsCritics = () => useContext(CreateNewsCriticsContext);
export default useCreateNewsCritics;
